import React from "react";
import ArrowIconComponent from "../icon/ArrowIcon";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";


interface ComparisionProps{
    currentLevel: data;
    threeYearAgo: data;
    feedback?: string;
}
interface data {
    groupTitle: string,
    totalPoint: number,
    totalQuestion: number,
    advice: string,
    avgPoint: number,
    stdevpPoint: number,
    deviation: number,
    exposition: string,
}
const ComparisonTableWithArrow: React.FC<{ data: ComparisionProps, text?: string }> = ({ data, text }) => {
    const compareDeviation = parseFloat((data.currentLevel.deviation - data.threeYearAgo.deviation).toFixed(2));


    return (
        <>
            <div className="pt-4">
                <span style={{whiteSpace: 'break-spaces' }}>
                        {text}
                        </span>
            </div>
            <div className={'d-flex'} style={{fontFamily: '源ノ角ゴシック JP', marginTop: '24px'}}>
                <div className={'div-table-comparision'} style={{backgroundColor: '#EFEFEF'}}>
                    <div className={'d-flex'}><div className={'blue-dot'} style={{marginRight: '4px'}}></div><span>3年前の活躍度合い</span></div>
                    <table className={"table-comparision mt-4"}>
                        <tbody>
                        <tr>
                            <td className={'p-4 thead'} style={{width: '30%'}}>スコア</td>
                            <td className={'p-4 data green'}>{data.threeYearAgo.totalPoint}</td>
                        </tr>
                        <tr>
                            <td className={'p-4 thead'}>偏差値</td>
                            <td className={'p-4 data green'}>{data.threeYearAgo.deviation}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                    {
                        <div className={'arrow-component'}><ArrowIconComponent a={data.threeYearAgo.totalPoint} b={data.currentLevel.totalPoint}/></div>
                    }
                <div className={'div-table-comparision'} style={{backgroundColor: '#E8F5FF'}}>
                    <div className={'d-flex'}><div className={'blue-dot'} style={{marginRight: '4px'}}></div><span>現在の活躍度合い</span></div>
                    <table className={"table-comparision mt-4"}>
                        <tbody>
                        <tr>
                            <td className={'p-4 thead'} style={{width: '30%'}}>スコア</td>
                            <td className={compareDeviation > 0 ? 'p-4 data green' : 'p-4 data red'}>{data.currentLevel.totalPoint}</td>
                        </tr>
                        <tr>
                            <td className={'p-4 thead'}>偏差値</td>
                            <td className={compareDeviation > 0 ? 'p-4 data green' : 'p-4 data red'}>{data.currentLevel.deviation} ({compareDeviation > 0 ? `+${compareDeviation}` : compareDeviation})</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            {
                data.feedback !== '' && data.feedback !== null &&
                <div className="pb-5 pt-5">
                    <ReactMarkdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]}>
                        {data.feedback}
                    </ReactMarkdown>
                </div>
            }

        </>
    );
}

export default ComparisonTableWithArrow;
